import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import {
  getConditionOptions,
  getSegmentOptions,
} from 'src/app/shared/helpers/Drop-down-options';
import { MatSort, Sort } from '@angular/material/sort';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-past-voyages',
  templateUrl: './past-voyages.component.html',
  styleUrls: ['./past-voyages.component.scss'],
})
export class PastVoyagesComponent {
  addRowdData: any[] = [];
  tableData: any[] = [];
  segmentOptions: any;
  condition: any;
  updateForm!: FormGroup;
  itemsPerPage: number = 100;
  currentPage: number = 0;
  paginatedData: any[] = [];
  @ViewChild(MatSort) sort!: MatSort;
  refreshSubscription!: Subscription;
  data: any;
  constructor(
    private portDetails: PortDetailsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private sharedDataService: DashboardService,
    private router: Router,
    private dialog: MatDialog,
    private requestFormService: RequestFormService
  ) {
    this.updateForm = this.fb.group({
      from_date: [''],
      to_date: [''],
      condition: [''],
      segment: [''],
      shipName: [''],
    });
    this.segmentOptions = getSegmentOptions();
    this.condition = getConditionOptions();
  }

  ngOnInit() {}
  loadData() {
    this.requestFormService.getReports().subscribe((data: any) => {
      const selectedRadio = localStorage.getItem('selectedRadio');
      if (selectedRadio === 'myShips') {
        const selectedOperator = localStorage.getItem('selectedOperator');
        this.data = data.filter(
          (item: any) => item.eigerpic === selectedOperator
        );
      } else {
        this.data = data;
      }
      const modifiedData = this.data.map((element: any) => {
        element.ship = this.removeShipPrefix(element.ship);
        return element;
      });
      this.tableData = modifiedData.filter(
        (element: any) => element.status === 'True'
      );
      this.filterClick();
    });
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  refresh() {
    this.loadData();
    this.startAutoRefresh();
  }
  startAutoRefresh() {
    this.refreshSubscription = interval(3600000).subscribe(() => {
      this.loadData();
    });
  }
  removeShipPrefix(shipName: string): string {
    if (!shipName) {
      return '';
    }

    // Remove known prefixes
    const cleanedName = shipName.replace(/^(MV|MT)\s*/i, '');

    return cleanedName
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(dateString: any) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    if (isNaN(year) || isNaN(date.getMonth()) || isNaN(date.getDate())) {
      return 'NA';
    }
    return `${year}-${month}-${day}`;
  }
  formatTime(dateString: any) {
    if (!dateString) return '';
    const dateParts = dateString.split(' ');
    if (dateParts.length < 2) return '';
    const time = dateParts[1];
    const timeParts = time.split(':');
    if (timeParts.length !== 2) return '';
    const hours = String(parseInt(timeParts[0], 10)).padStart(2, '0');
    const minutes = String(parseInt(timeParts[1], 10)).padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  convertToUTC(updatedAtString: any) {
    if (!updatedAtString) return '';
    const date = new Date(updatedAtString);
    if (isNaN(date.getTime())) return '';
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.tableData?.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, sort.active, isAsc);
    });
  }

  compare(a: any, b: any, sortActive: string, isAsc: boolean) {
    if (sortActive === 'etaDate') {
      const dateA = new Date(a[sortActive]);
      const dateB = new Date(b[sortActive]);

      if (dateA < dateB) {
        return isAsc ? -1 : 1;
      } else if (dateA > dateB) {
        return isAsc ? 1 : -1;
      }
      return 0;
    }

    if (a === null || a === undefined) return isAsc ? -1 : 1;
    if (b === null || b === undefined) return isAsc ? 1 : -1;

    const aNum = parseFloat(a[sortActive]);
    const bNum = parseFloat(b[sortActive]);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return (aNum < bNum ? -1 : 1) * (isAsc ? 1 : -1);
    }

    if (
      typeof a[sortActive] === 'string' &&
      typeof b[sortActive] === 'string'
    ) {
      return a[sortActive].localeCompare(b[sortActive]) * (isAsc ? 1 : -1);
    }

    return (a[sortActive] < b[sortActive] ? -1 : 1) * (isAsc ? 1 : -1);
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  clearClick() {
    this.updateForm.reset();
    this.paginateData();
  }
  filterClick() {
    const from_date_str = this.updateForm.get('from_date')?.value;
    const to_date_str = this.updateForm.get('to_date')?.value;
    const segment = this.updateForm.get('segment')?.value;
    const condition = this.updateForm.get('condition')?.value;
    const shipName = this.updateForm.get('shipName')?.value;
    const filteredData = this.tableData.filter((element: any) => {
      const fromDateValid =
        !from_date_str || element.updatedAt >= from_date_str;
      const toDateValid = !to_date_str || element.updatedAt <= to_date_str;
      const segmentValid =
        !segment || element.segment?.toLowerCase() === segment.toLowerCase();
      const conditionValid =
        !condition ||
        element.voyageType?.toLowerCase() === condition.toLowerCase();
      const shipNameFilter =
        !shipName ||
        element.ship?.toLowerCase().includes(shipName.toLowerCase());
      return (
        fromDateValid &&
        toDateValid &&
        segmentValid &&
        conditionValid &&
        shipNameFilter
      );
    });
    this.paginatedData = filteredData.slice(0, this.itemsPerPage);
    this.currentPage = 0;
  }

  exportClick() {
    let csvContent = 'data:text/csv;charset=utf-8,';
    const headerRow = [
      'Ship Name',
      'Customer Name',
      'Segment',
      'Meraki Pic',
      'From',
      'To',
      'ETA(LT)',
      'Condition',
      'CP Speed',
      'Time Updated(UTC)',
    ].join(',');
    csvContent += headerRow + '\r\n';
    this.tableData.forEach((row) => {
      const values = [
        row.ship,
        row.customername,
        row.segment,
        row.merakiPic,
        row.pFrom,
        row.pTo,
        row.etaDate,
        row.voyageType,
        row.cpOrderedSpeed,
        this.convertToUTC(row.updatedAt),
      ];
      const csvRow = values
        .map((value) => {
          if (value && typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
          return value;
        })
        .join(',');
      csvContent += csvRow + '\r\n';
    });
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Past_Voyages.csv');
    document.body.appendChild(link);
    link.click();
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
